import { scrollDown } from 'icons/scrollDown';
import './scrollToBottom.scss';

export const ScrollBottomTemplate = (model) => {
	const { id } = model;

	const html =
		/* html */
		`<button 
			id="engtScrollBtn"
			class="engt-scrl-down-btn engt-scrl-down-btn-hidden" 
			aria-label="scroll-down" 
			data-scroll-for="${id}"
			onclick="ENGT_CHAT.scrollDown(this)"
		>
			${scrollDown()}
		</button>
		`;

	return html;
};
